@import '@hevoio/hevo-ui-toolkit/styles/variables';

.switchLabel {
  font-weight: $font-weight-bold !important;
  margin-bottom: $spacer * 0.25 !important;
}
